import React from 'react';

import { useScrollToSelectedElement } from '../hooks/useScrollToSelectedElement';
import { useFilters } from '../hooks/useFilters';
import { useHash } from '../hooks/useHash';

import Filters from './Filters';
import Section from './Section';

export default function FilteredSections({ section }) {
  const { references } = section;

  const { setSelectedElement, selectedElement } = useFilters(references);

  // SELECT SPECIFIC SECTION BASED ON URL HASH
  useHash(references, setSelectedElement);

  useScrollToSelectedElement(selectedElement);

  return (
    <>
      {references && (
        <div className="filtered-sections">
          <Filters
            filters={references}
            handleClick={setSelectedElement}
            selectedElement={selectedElement}
          />
          {selectedElement && (
            <Section key={selectedElement.id} section={selectedElement} />
          )}
        </div>
      )}
    </>
  );
}
